import { render, staticRenderFns } from "./CustomerOrderDetail.vue?vue&type=template&id=3ae93ec6"
import script from "./CustomerOrderDetail.vue?vue&type=script&lang=js"
export * from "./CustomerOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderDetail.vue?vue&type=style&index=0&id=3ae93ec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports